import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header style={{
      background: '#000000',
      borderBottom: '1px solid rgba(255, 255, 255, 0.25)',
      padding: '16px 7.6923%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'fixed',
      top: 0,
      width: '100%',
      height: '80px',
      zIndex: 10,
      boxSizing: 'border-box'
    }}>
      <div style={{
        fontSize: '28px',
        fontWeight: 600,
        color: '#00FFD1',
        cursor: 'pointer',
        letterSpacing: '-0.02em'
      }} onClick={() => scrollToSection('hero')}>
        PIXELINUX
      </div>

      {/* Desktop Navigation */}
      <nav style={{
        display: 'flex',
        alignItems: 'center',
        gap: '32px'
      }} className="desktop-nav">
        <a onClick={() => scrollToSection('nosotros')} style={{
          color: '#4D4D4D',
          textDecoration: 'none',
          fontSize: '18px',
          fontWeight: 400,
          transition: 'color 0.3s ease',
          cursor: 'pointer'
        }} onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
          onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
          Nosotros
        </a>
        <a onClick={() => scrollToSection('products')} style={{
          color: '#4D4D4D',
          textDecoration: 'none',
          fontSize: '18px',
          fontWeight: 400,
          transition: 'color 0.3s ease',
          cursor: 'pointer'
        }} onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
          onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
          Productos
        </a>
        <a onClick={() => scrollToSection('features')} style={{
          color: '#4D4D4D',
          textDecoration: 'none',
          fontSize: '18px',
          fontWeight: 400,
          transition: 'color 0.3s ease',
          cursor: 'pointer'
        }} onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
          onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
          Características
        </a>
        <a onClick={() => scrollToSection('contact')} style={{
          color: '#4D4D4D',
          textDecoration: 'none',
          fontSize: '18px',
          fontWeight: 400,
          transition: 'color 0.3s ease',
          cursor: 'pointer'
        }} onMouseEnter={(e) => e.target.style.color = '#FFFFFF'}
          onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
          Contacto
        </a>
        <button className="btn-primary" onClick={() => scrollToSection('contact')}>
          Tickets
        </button>
      </nav>

      {/* Mobile Menu Button */}
      <button
        className="mobile-menu-btn"
        style={{
          display: 'none',
          background: 'transparent',
          border: 'none',
          color: '#FFFFFF',
          cursor: 'pointer'
        }}
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
      </button>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div style={{
          position: 'fixed',
          top: '80px',
          left: 0,
          right: 0,
          background: '#000000',
          borderBottom: '1px solid rgba(255, 255, 255, 0.25)',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          zIndex: 9
        }} className="mobile-menu">
          <a onClick={() => scrollToSection('nosotros')} style={{
            color: '#FFFFFF',
            textDecoration: 'none',
            fontSize: '18px',
            cursor: 'pointer'
          }}>
            Nosotros
          </a>
          <a onClick={() => scrollToSection('products')} style={{
            color: '#FFFFFF',
            textDecoration: 'none',
            fontSize: '18px',
            cursor: 'pointer'
          }}>
            Productos
          </a>
          <a onClick={() => scrollToSection('features')} style={{
            color: '#FFFFFF',
            textDecoration: 'none',
            fontSize: '18px',
            cursor: 'pointer'
          }}>
            Características
          </a>
          <a onClick={() => scrollToSection('contact')} style={{
            color: '#FFFFFF',
            textDecoration: 'none',
            fontSize: '18px',
            cursor: 'pointer'
          }}>
            Contacto
          </a>
          <button className="btn-primary" onClick={() => scrollToSection('contact')} style={{ width: '100%' }}>
            Comenzar
          </button>
        </div>
      )}

      <style jsx="true">{`
        @media (max-width: 767px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
